import { render, staticRenderFns } from "./CustomerTickets.vue?vue&type=template&id=de12084c"
import script from "./CustomerTickets.vue?vue&type=script&lang=js"
export * from "./CustomerTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports